import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import * as moment from "moment";
import axios from "axios";
import DatePicker from "react-multi-date-picker";
import { Image } from "hesus-ui-kit";
import Solutions from "../Solutions";
import ValidateService from "./ValidateService";
import commentIcon from "@icons/ic-comment.svg";
import editIcon from "@icons/ic-edit-blue.svg";
import cancelIcon from "@icons/ic-cancel.svg";
import saveIcon from "@icons/ic-green-edit.svg";
import erpNotSync from "@icons/erpNotSync.svg";
import erpSync from "@icons/erpSync.svg";
import {
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
  addSpace,
} from "@utils/utils";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";

import { DivToolTip } from "@utils/extra-style";

import {
  GridRow,
  GridSubItem,
  GridSubLabel,
  GridItem,
  HorizontalRow,
  FlexRow,
  ServiceInfo,
  GridDateDiv,
  ImgDiv,
} from "./QuoteView.styled";

const QuoteItems = (props) => {
  const {
    t,
    itemList,
    enquiryId,
    sellingPriceId,
    currency,
    quoteId,
    siteId,
    setQuoteData,
    isSiteCommentEdit,
    koStatus,
    isOperationType,
    setIsRefreshQuoteData,
    isStudyTeamType,
    setIsRefeshSiteData,
  } = props;

  const [editDate, setEditDate] = useState(false);
  const [editDateId, setEditDateId] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");

  const getMarginColor = (margin) => {
    let color = "orange";
    if (margin >= 8) {
      color = "green";
    }
    if (margin <= 0) {
      color = "red";
    }
    return color;
  };

  const toggleDateInfo = (id) => {
    setEditDate(!editDate);
    setEditDateId(id);
  };

  const editDateInfo = (id, startDate, endDate) => {
    setEditDate(!editDate);
    setEditDateId(id);
    if (startDate) setStartDate(moment(startDate).format("YYYY-MM-DD"));
    if (endDate) setEndDate(moment(endDate).format("YYYY-MM-DD"));
  };

  const validateForm = (data) => {
    let isFormValid = true;
    if (!startDate) {
      isFormValid = false;
      setStartDateError("FIELD_REQUIRED");
    }
    if (!endDate) {
      isFormValid = false;
      setEndDateError("FIELD_REQUIRED");
    }
    return isFormValid;
  };
  const updateDate = (itemId) => {
    const isFormValid = validateForm();
    if (isFormValid) {
      const data = {
        itemId,
        startDate,
        endDate,
        siteId,
      };
      axios
        .put(`/quotes/${quoteId}/item/${itemId}`, data)
        .then((response) => {
          setQuoteData(response.data[0]);
          setStartDate("");
          setEndDate("");
          setEditDate(!editDate);
          setEditDateId("");
          setStartDateError("");
          setEndDateError("");
        })
        .catch((error) => {
          if (window.debugMode) {
            console.error(
              "Error: an error occurred while updating dates",
              error
            );
          }
          setEditDate(!editDate);
          setEditDateId("");
        });
    }
  };

  const onStartDateChange = (e) => {
    if (e !== null) {
      setStartDate(moment(e.toDate()).format("YYYY-MM-DD"));
    } else {
      setStartDate("");
    }
    setStartDateError("");
  };

  const onEndDateChange = (e) => {
    if (e !== null) {
      setEndDate(moment(e.toDate()).format("YYYY-MM-DD"));
    } else {
      setEndDate("");
    }
    setEndDateError("");
  };

  const getItemKoStatus = (itemInfo) => {
    let status = parseInt(itemInfo?.koStatus, 10);
    if (itemInfo.hesusCatalogService.combination) {
      itemList.map((itemData) => {
        if (
          itemData.hesusService.needProduct &&
          !itemData.hesusService.needTransport
        ) {
          status = parseInt(itemData?.koStatus, 10);
        }
      });
    }
    return status;
  };

  return (
    <>
      {itemList?.length > 0 &&
        itemList.map((item, itemIndex) => {
          return (
            <React.Fragment key={"quote-item" + item?.id + itemIndex}>
              {itemIndex !== 0 && <HorizontalRow />}
              <GridRow
                column="57% 10% 10% 13% 10%"
                marginBottom="0px"
                gridGap="0rem"
                marginTop="0px"
              >
                <GridItem>
                  <GridRow
                    column={
                      parseInt(item?.koStatus, 10) === 1 ? "auto 1fr" : "1fr"
                    }
                  >
                    {parseInt(item?.koStatus, 10) === 1 && (
                      <ImgDiv>
                        <Image
                          src={
                            parseInt(item?.isErpSync, 10) === 1
                              ? erpSync
                              : erpNotSync
                          }
                          alt={
                            parseInt(item?.isErpSync, 10) === 1
                              ? t("OPS_SYNCRO_DONE")
                              : t("OPS_SYNCRO_NOT_DONE")
                          }
                          title={
                            parseInt(item?.isErpSync, 10) === 1
                              ? t("OPS_SYNCRO_DONE")
                              : t("OPS_SYNCRO_NOT_DONE")
                          }
                          styles={{
                            height: "25px",
                            width: "25px",
                            cursor: "pointer",
                          }}
                        />
                      </ImgDiv>
                    )}
                    <GridRow
                      column="1fr 10%"
                      marginBottom="0px"
                      gridGap="0rem"
                      marginTop="0px"
                    >
                      <FlexRow
                        column="auto 1fr"
                        marginBottom="0px"
                        gridGap=".50rem"
                        marginTop="0px"
                      >
                        <GridSubLabel>{String(item?.label) || ""}</GridSubLabel>
                        <GridSubItem>
                          {item.hesusService.needProduct && item.product.name}
                          {item.hesusService.needProduct &&
                            item.hesusService.needTransport &&
                            " - "}
                          {item.hesusService.needTransport &&
                            item?.transport?.name}
                        </GridSubItem>
                      </FlexRow>
                      <div>
                        {item?.description && (
                          <>
                            <span id={`quite-item-description-id${item.id}`}>
                              <Image
                                src={commentIcon}
                                alt="comment"
                                styles={{
                                  height: "20px",
                                  width: "20px",
                                  cursor: "pointer",
                                }}
                              />
                            </span>
                            <Tooltip
                              anchorSelect={`#quite-item-description-id${item.id}`}
                              style={DivToolTip}
                              content={item?.description}
                            />
                          </>
                        )}
                      </div>
                      <GridRow
                        column="auto 1fr"
                        marginBottom="0px"
                        gridGap=".25rem"
                      >
                        <GridSubItem color="#0a4986" fontstyle="normal">
                          {t("QUOTE_ITEM_ESTIMATED_DATES")} :
                        </GridSubItem>
                        {(!editDate ||
                          parseInt(editDateId, 10) !==
                            parseInt(item.id, 10)) && (
                          <GridSubItem color="#0a4986">
                            {item.startDate
                              ? getDateFormat(item.startDate, "YYYY-MM-DD")
                              : "-"}{" "}
                            {" - "}
                            {item.endDate
                              ? getDateFormat(item.endDate, "YYYY-MM-DD")
                              : "-"}
                            {parseInt(isSiteCommentEdit, 10) > 0 &&
                              parseInt(koStatus, 10) === 0 && (
                                <Image
                                  src={editIcon}
                                  alt={t(
                                    "KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_EDIT"
                                  )}
                                  title={t(
                                    "KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_EDIT"
                                  )}
                                  styles={{
                                    height: "20px",
                                    width: "20px",
                                    cursor: "pointer",
                                    marginLeft: "20px",
                                  }}
                                  onClick={() =>
                                    editDateInfo(
                                      item.id,
                                      item.startDate,
                                      item.endDate
                                    )
                                  }
                                />
                              )}
                          </GridSubItem>
                        )}
                        {editDate &&
                          parseInt(editDateId, 10) ===
                            parseInt(item.id, 10) && (
                            <GridDateDiv fontstyle="normal" color="#474747">
                              <DatePicker
                                inputClass={
                                  startDateError
                                    ? "kickoff-quote-view__date-input-error"
                                    : "kickoff-quote-view__date-input"
                                }
                                containerClassName="kickoff-quote-view__datepicker-container"
                                type="text"
                                label=""
                                name="kickoff-quote-view-start-date"
                                id="kickoff-quote-view-start-date"
                                calendarPosition="bottom-center"
                                isFloat
                                onChange={onStartDateChange}
                                format={getDatePickerFormat()}
                                locale={getCalendarLocale()}
                                value={
                                  getDateFormat(startDate, "YYYY-MM-DD") || ""
                                }
                                containerStyles={{ marginTop: "21px" }}
                                required
                                placeholder=""
                              />
                              <DatePicker
                                inputClass={
                                  endDateError
                                    ? "kickoff-quote-view__date-input-error"
                                    : "kickoff-quote-view__date-input"
                                }
                                containerClassName="kickoff-quote-view__datepicker-container"
                                type="text"
                                label=""
                                name="kickoff-quote-view-start-date"
                                id="kickoff-quote-view-start-date"
                                calendarPosition="bottom-center"
                                isFloat
                                onChange={onEndDateChange}
                                format={getDatePickerFormat()}
                                locale={getCalendarLocale()}
                                value={
                                  getDateFormat(endDate, "YYYY-MM-DD") || ""
                                }
                                containerStyles={{ marginTop: "21px" }}
                                required
                                placeholder=""
                              />
                              <Image
                                src={saveIcon}
                                alt={t(
                                  "KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE"
                                )}
                                title={t(
                                  "KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE"
                                )}
                                styles={{
                                  height: "20px",
                                  width: "20px",
                                  cursor: "pointer",
                                  marginRight: "12px",
                                  marginTop: "6px",
                                }}
                                onClick={() => updateDate(item.id)}
                              />
                              <Image
                                src={cancelIcon}
                                alt={t(
                                  "KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL"
                                )}
                                title={t(
                                  "KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL"
                                )}
                                styles={{
                                  height: "20px",
                                  width: "20px",
                                  cursor: "pointer",
                                  marginTop: "6px",
                                }}
                                onClick={() => toggleDateInfo(item.id)}
                              />
                            </GridDateDiv>
                          )}
                      </GridRow>
                    </GridRow>
                  </GridRow>
                </GridItem>
                <GridItem>{item.quantity + " " + t(item?.unit)}</GridItem>
                <GridItem>
                  {renderPriceWithCurrency(
                    addSpace(item?.itemSellingPrice),
                    t(item?.unit),
                    currency?.symbol,
                    currency?.position
                  )}
                </GridItem>
                <GridItem
                  textAlign="right"
                  backgroundColor="#e2edf6"
                  fontWeight="700"
                  borderRight="2px solid rgba(10, 73, 134, 0.3)"
                >
                  {renderPriceWithCurrencyWithoutUnit(
                    addSpace(item?.sellingPriceExcludedTax),
                    currency?.symbol,
                    currency?.position
                  )}
                </GridItem>

                <GridItem
                  textAlign="right"
                  color={getMarginColor(item.margin)}
                  borderRight="0px solid rgba(10, 73, 134, 0.3)"
                >
                  {item.margin + " %"}
                </GridItem>
              </GridRow>
              {parseInt(koStatus, 10) > 0 && item.hesusService.needSolution && (
                <Solutions
                  solutionList={item.sellingPriceItem?.solutions}
                  koStatus={item?.koStatus}
                  isOperationType={isOperationType}
                  sellingPriceId={sellingPriceId}
                  setIsRefreshQuoteData={setIsRefreshQuoteData}
                  isStudyTeamType={isStudyTeamType}
                  hesusService={item.hesusService}
                  combination={item.hesusCatalogService.combination}
                />
              )}

              {parseInt(koStatus, 10) > 0 &&
                parseInt(item?.koStatus, 10) === 0 &&
                parseInt(isOperationType, 10) > 0 && (
                  <ValidateService
                    hesusService={item.hesusService}
                    sellingPriceItem={item.sellingPriceItem}
                    combination={item.hesusCatalogService.combination}
                    // itemKoStatus={parseInt(item?.koStatus, 10)}
                    setQuoteData={setQuoteData}
                    quoteId={quoteId}
                    itemId={item.id}
                    itemKoStatus={getItemKoStatus(item)}
                    setIsRefeshSiteData={setIsRefeshSiteData}
                  />
                )}
            </React.Fragment>
          );
        })}
      {(itemList?.length === 0 || itemList === null) && (
        <ServiceInfo color="#767676">{t("QUOTE_NO_ITEMS")}</ServiceInfo>
      )}
    </>
  );
};

QuoteItems.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
QuoteItems.defaultProps = {
  id: null,
};

export default withTranslation()(QuoteItems);
